var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYourpagebusiness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 16H16.8V18.6667H19.2M19.2 10.6667H16.8V13.3333H19.2M21.6 21.3333H12V18.6667H14.4V16H12V13.3333H14.4V10.6667H12V8H21.6M9.6 5.33333H7.2V2.66667H9.6M9.6 10.6667H7.2V8H9.6M9.6 16H7.2V13.3333H9.6M9.6 21.3333H7.2V18.6667H9.6M4.8 5.33333H2.4V2.66667H4.8M4.8 10.6667H2.4V8H4.8M4.8 16H2.4V13.3333H4.8M4.8 21.3333H2.4V18.6667H4.8M12 5.33333V0H0V24H24V5.33333H12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYourpagebusiness);
export default __webpack_public_path__ + "static/media/yourpagebusiness.74e511e708b17b44a9ec2d7b9ad50933.svg";
export { ForwardRef as ReactComponent };